import { useState } from 'react';
import { subscribeNewsletter } from '@/lib/api';

/**
 * Fire-and-forget subscription state (SH-368 D4): the request either lands or
 * the visitor retries — nothing is queued or persisted on our side. On success
 * the widget swaps the form for a confirmation and does not reset it, so a
 * second address needs a page reload (D11).
 */
export function useNewsletterSubmit() {
  const [submitted, setSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleSubmit = async (email: string): Promise<void> => {
    setHasError(false);
    try {
      await subscribeNewsletter({ email });
      setSubmitted(true);
    } catch {
      setHasError(true);
    }
  };

  return { submitted, hasError, handleSubmit };
}
